 import React from 'react';
 import { useState} from 'react';
 import '../styles/Home.css';
 import { Link } from 'react-router-dom';
 
 
 const aboutus = () => {
  
   return (
<div>



 <section className="about-us">
 <h1 classname="headerh1">Hello</h1>
 <p>
 🎱 Welcome to Snooker Hut – Nanganallur’s Ultimate Snooker & Gaming Lounge<br></br>
Looking for the best snooker spot, gaming café, or a chill hangout in South Chennai?<br></br>
Your search ends here. Snooker Hut in Nanganallur brings you the perfect mix of competitive spirit and pure fun — from cue sports to console showdowns.<br></br>
Step into a neon-lit, fully air-conditioned lounge designed for snooker lovers, casual players, and hardcore gamers alike. <br></br>
Whether you're dropping in for a quick 8 ball match or planning a full-blown gaming night, Snooker Hut has everything you need to play, relax, and repeat.<br></br>
</p>
<h1 classname="headerh1">🎯 What’s Inside the Hut?</h1>
<p>✅ 6 Premium Snooker & Pool Tables – S1, S2, S3, M1, M2, M3<br></br>
✅ 8 Ball Pool Tournaments, Cash Prizes & Training Sessions<br></br>
✅ PlayStation 4 & 5 Multiplayer Gaming<br></br>
✅ High-End PC Gaming Zone with the Latest Titles<br></br>
✅ Online Table Booking with Discounts<br></br>
✅ Cool, Clean & Safe Space – Fully Air-Conditioned<br></br>
✅ All-Age Friendly Vibe<br></br>
✅ Open Daily: 11 AM to 3 AM – Perfect for Night Owls<br></br>

Whether you're a pro cue artist, weekend warrior, or someone simply searching for “snooker near me” or “late-night gaming lounge,” Snooker Hut is your go-to destination.
</p>
<h1 classname="headerh1">🧠 Who’s Snooker Hut For?</h1>
<p>

🎱 Snooker & Pool Lovers – Beginners, casual players, and pros searching for 8 ball pool near me or top billiards spots in Chennai<br></br>
🎮 Console & PC Gamers – Bring your squad or go solo<br></br>
👫 Couples & Friends – Perfect for fun evenings or weekend chill<br></br>
🕹️ Late-Night Gamers – We’re open till 3 AM!<br></br>
✨ Anyone searching “fun things to do near me” in Chennai </p>
</section>

</div>
    
);
};

export default aboutus;